import {
  IRaffleDealParticipateErrorPayload,
  IRaffleDealV3ParticipatePayload,
} from '@/models/RaffleDeal/interfaces/IRaffleDealParticipatePayload';
import { IRaffleDealParticipateRequestParams } from '@/models/RaffleDeal/interfaces/IRaffleDealParticipateRequestParams';
import { RaffleDealActions } from '@/models/RaffleDeal/RaffleDealActions';
import { RaffleDealRequestBuilder } from '@/models/RaffleDeal/RaffleDealRequestBuilder';
import { IRequesterError } from '@/services/RequestService/IRequester';
import reactQueryResponseHandler from '@/utils/hooks/react_query/reactQueryResponseHandler';
import { ISunnyMutationOptions, useSunnyMutation } from '@/utils/hooks/react_query/useSunnyQuery';
import type { UseMutationResult } from 'react-query';

const postV3Participate = (params: IRaffleDealParticipateRequestParams): Promise<IRaffleDealV3ParticipatePayload> => {
  const actions = new RaffleDealActions(RaffleDealRequestBuilder);
  const result = actions.postParticipate(params);
  return reactQueryResponseHandler(result);
};

const useRaffleDealV3ParticipateMutation = (
  options: ISunnyMutationOptions<
    IRaffleDealV3ParticipatePayload,
    IRequesterError<IRaffleDealParticipateErrorPayload>,
    IRaffleDealParticipateRequestParams
  >,
): UseMutationResult<
  IRaffleDealV3ParticipatePayload,
  IRequesterError<IRaffleDealParticipateErrorPayload>,
  IRaffleDealParticipateRequestParams
> => {
  return useSunnyMutation(postV3Participate, {
    ...options,
    retry: false,
  });
};

export default useRaffleDealV3ParticipateMutation;
